export default __webpack_public_path__ + "static/media/chaked-profile.1c22dcc8.svg";